import type { TaskWithFlags } from "@desk/contracts";

/** Tasks currently rendered anywhere, so global shortcuts and menus can act on the keyboard selection. */
export const taskRegistry = new Map<string, TaskWithFlags>();
